import React, { useState, useEffect } from "react";
import { Table, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { SuperAdminTopTextSearchIcon } from "./AllDonationFilter";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { get_donation_report } from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import TodayDateTime from "../../../reusableComponents/AllDateComponents/TodayDateTime";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

const SuperAdminDonationReport = (props) => {
  //state
  const [showFilter, seShowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    setPage(pageNo);
  };
  const handleShowFilter = () => {
    seShowFilter({
      showFilter: !showFilter.showFilter,
    });
  };
  const [search, setSearch] = useState("");
  const [selectedOrganizationName, setSelectedOrganizationName] = useState("");
  const [selectedOrganizationName1, setSelectedOrganizationName1] =
    useState("");
  const [sortByDay, setSortByDay] = useState(4);
  const [startDay, setStartDay] = useState("");
  const [endDay, setEndDay] = useState("");

  const changeSortByDay = (e) => {
    setSortByDay(e);
    let startDate = "";
    let endDate = new Date();
    if (e === 2) {
      startDate = new Date(new Date().setDate(new Date().getDate() - 30));
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    } else if (e === 1) {
      startDate = new Date();
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    } else if (e === 3) {
      startDate = new Date(new Date().setDate(new Date().getDate() - 90));
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    }
  };

  const onClickSearch = () => {
    setSelectedOrganizationName1(selectedOrganizationName);
  };

  const onClickCancel = () => {
    setSelectedOrganizationName1("");
    setSelectedOrganizationName("");
  };

  const [sortBy, setSortBy] = useState("a");
  const changeSortBy = (e) => {
    setSortBy(e);
  };
  var filteredData =
    props &&
    props.all_donations_report &&
    props.all_donations_report.sort(function (a, b) {
      let nameA = a && a.organization_name.toUpperCase(); // ignore upper and lowercase
      let nameB = b && b.organization_name.toUpperCase(); // ignore upper and lowercase
      if (sortBy === "a") {
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      } else {
        if (nameB < nameA) {
          return -1;
        }
        if (nameB > nameA) {
          return 1;
        }
      }

      // names must be equal
      return 0;
    });

  filteredData = filteredData.filter((item) => {
    return (
      item &&
      item.organization_name &&
      item.organization_name.toLowerCase().includes(search.toLowerCase())
    );
  });

  if (selectedOrganizationName1 !== "") {
    filteredData = filteredData.filter((item) => {
      return item && item.organization_id === selectedOrganizationName1;
    });
  }

  if (sortByDay !== 4) {
    filteredData = filteredData.filter((item) => {
      return (
        (startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
          startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
        (moment(item.createdAt).format("YYYY-MM-DD") <= endDay ||
          moment(item.updatedAt).format("YYYY-MM-DD") <= endDay)
      );
    });
  }
  const onSuccess = () => {};

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_donation_report(token, onSuccess);
  }, []);

  const [organizationName, setOrganizationName] = useState([]);

  const [totalAmount, setTotalAmount] = useState(0);
  useEffect(() => {
    let totalSum = 0;
    let orgDetails = [];
    let orgId = [];
    for (let i = 0; i < props.all_donations_report.length; i++) {
      totalSum += parseInt(props.all_donations_report[i].donation_amount);
      if (!orgId.includes(props.all_donations_report[i].organization_id)) {
        orgId.push(props.all_donations_report[i].organization_id);
        orgDetails.push({
          id: props.all_donations_report[i].organization_id,
          title: props.all_donations_report[i].organization_name,
        });
      }
    }
    setOrganizationName(orgDetails);
    setTotalAmount(totalSum);
  }, [props.all_donations_report]);
  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <div className="super-admin-inside-right-side-panel">
                  <TodayDateTime />
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                    <div className="f24_700_HelveticaNeue">Donation Report</div>
                    <div className="d-flex align-items-center">
                      <div
                        className="p-2 mr-3"
                        style={{ backgroundColor: "#e6e6ff", color: "#9900ff" }}
                      >
                        <div className="f12-500" style={{ color: "#9900ff" }}>
                          Total No. of Organizations
                        </div>
                        <div className="f18-700">
                          {props.all_donations_report.length}
                        </div>
                      </div>{" "}
                      <div
                        className="p-2 mr-3"
                        style={{
                          backgroundColor: "#eafafa",
                          color: "#1d7c7c",
                          minWidth: "150px",
                        }}
                      >
                        <div className="f12-500" style={{ color: "#1d7c7c" }}>
                          Total Amount
                        </div>
                        <div className="f18-700">₹ {totalAmount}</div>
                      </div>
                      <NavLink
                        to="/superadmindonation"
                        className="btn btn-outline-secondary btn-lg"
                      >
                        View Open Items For Donation
                      </NavLink>
                    </div>
                  </div>
                  <SuperAdminTopTextSearchIcon
                    showFilter={showFilter.showFilter}
                    handleShowFilter={handleShowFilter}
                    onChange={(e) => setSearch(e)}
                    search={search}
                    sortBy={sortBy}
                    changeSortBy={(e) => changeSortBy(e)}
                    organizationName={organizationName}
                    type="report"
                    selectedOrganizationName={selectedOrganizationName}
                    setSelectedOrganizationName={(e) =>
                      setSelectedOrganizationName(e)
                    }
                    onClickSearch={() => onClickSearch()}
                    onClickCancel={() => onClickCancel()}
                    sortByDay={sortByDay}
                    changeSortByDay={(e) => changeSortByDay(e)}
                  />
                  <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                    <Table className="HideShowTable enMinWidth900">
                      <thead>
                        <tr className="super_admin_all_users_table_head">
                          <th style={{ width: "10%" }} className="f12-700">
                            Organization
                            <br />
                            ID
                          </th>
                          <th style={{ width: "15%" }} className="f12-700">
                            Organization
                            <br />
                            Name
                          </th>
                          <th style={{ width: "12%" }} className="f12-700">
                            Donation Amount
                          </th>
                          <th style={{ width: "15%" }} className="f12-700">
                            Period
                          </th>
                          <th style={{ width: "12%" }} className="f12-700">
                            Status
                          </th>
                          <th style={{ width: "20%" }} className="f12-700">
                            Action
                          </th>
                        </tr>
                      </thead>
                      {console.log(filteredData)}
                      <tbody>
                        {filteredData &&
                          filteredData.map((organization, index) => (
                            <tr
                              className="super_admin_all_users_table_body"
                              key={index}
                            >
                              <td style={{ width: "10%" }}>
                                <div className="f12-400 text-break">
                                  {organization.organization_id}
                                </div>
                              </td>
                              <td style={{ width: "15%" }}>
                                <div className="f12-400">
                                  {organization.organization_name}
                                </div>
                              </td>
                              <td style={{ width: "12%" }}>
                                <div className="f12-400">
                                  ₹ {organization.donation_amount}
                                </div>
                              </td>
                              <td style={{ width: "15%" }}>
                                <div className="f12-400">
                                  {moment(organization.donation_date).format(
                                    "DD MMM, YYYY"
                                  )}
                                </div>
                              </td>
                              <td style={{ width: "12%" }}>
                                <div className="enSuccessLBL">
                                  {organization.payment_status}
                                </div>
                              </td>
                              <td style={{ width: "20%" }}>
                                <NavLink
                                  to={`/superadmindonationdetails/${
                                    organization.organization_id
                                  }/${organization._id}/${
                                    organization.donateByReferral ? 2 : 1
                                  }`}
                                  className="enIconBtn"
                                >
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/eye.svg")}
                                    alt="View"
                                    title="View"
                                    width="16px"
                                    fluid
                                  />
                                </NavLink>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                  {filteredData?.length > 0 ? (
                    <BasicPagination
                      totalRecords={filteredData.length}
                      limit={10}
                      batch={page}
                      onBatchChange={(e) => handleBatchChange(e)}
                    />
                  ) : (
                    <> </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

SuperAdminDonationReport.propTypes = {
  auth: PropTypes.object.isRequired,

  get_donation_report: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  all_donations_report: state.superadminManageTransactions.all_donations_report,
});

export default connect(mapStateToProps, {
  get_donation_report,
})(SuperAdminDonationReport);
